import {Injectable} from '@angular/core';
import {BaseService} from '../../common/base.service';
import {Observable} from 'rxjs';
import {ProductionJob} from '../pot/production-job';
import {catchError} from 'rxjs/operators';
import {CreateStockWithProductionJob} from '../pot/pot-jobs/create-stock-dialog/create-stock-with-production-job';
import {CuttingProductionJob} from './cutting-jobs/cutting-production-job';
import {PlugStock} from './plugStock';


@Injectable()
export class CuttingProductionJobService extends BaseService {

  private url = this.baseUrl + '/cutting-production-job';

  getAllProductionJobsForWeek(fromDate: string, untilDate: string): Observable<CuttingProductionJob[]> {
    const dateObject = {fromDate: fromDate, untilDate: untilDate};
    return this.http.post<CuttingProductionJob[]>(this.url + '/week', dateObject)
      .pipe(catchError(this.handleError('ophalen van alle oppot opdrachten', [])));
  }

  getAllProductionJobs(): Observable<CuttingProductionJob[]> {
    return this.http.post<CuttingProductionJob[]>(this.url + '/week', null)
      .pipe(catchError(this.handleError('ophalen van alle oppot opdrachten', [])));
  }

  createNewStockEntity(newStockEntity: CreateStockWithProductionJob) {
    return this.http.post<ProductionJob>(this.url + '/create-stock', newStockEntity)
      .pipe(catchError(this.handleError('Aanmaken van stock', [])));
  }

  findById(id: number): Observable<CuttingProductionJob> {
    const url = `${this.url}/${encodeURIComponent(String(id))}`;
    return this.http.get<CuttingProductionJob>(url).pipe(
      catchError(this.handleError<CuttingProductionJob>(`Cutting production job findById id=${id}`))
    );
  }

}
